import React from 'react';
import { useNavigate } from 'react-router-dom';

const WelcomePage = () => {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '100vh', background: 'var(--cr-primary)', display: 'flex', flexDirection: 'column' }}>
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '40px 24px' }}>
        <div style={{ width: 84, height: 84, borderRadius: 24, background: 'rgba(255,255,255,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 20 }}>
          <svg viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.5" width="46" height="46">
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
            <circle cx="9" cy="7" r="1" fill="white" />
            <circle cx="15" cy="7" r="1" fill="white" />
          </svg>
        </div>
        <h1 style={{ color: 'white', fontSize: 30, fontWeight: 700, textAlign: 'center' }}>Connected Rider</h1>
        <p style={{ color: 'rgba(255,255,255,0.85)', fontSize: 15, marginTop: 8, textAlign: 'center' }}>Horse care, community & marketplace</p>
      </div>

      <div style={{ padding: '0 24px 48px', display: 'flex', flexDirection: 'column', gap: 14 }}>
        <button
          onClick={() => navigate('/register')}
          style={{ width: '100%', padding: '18px', borderRadius: 9999, background: 'white', color: 'var(--cr-primary)', fontSize: 17, fontWeight: 600, border: 'none', cursor: 'pointer' }}>
          Create an account
        </button>
        <button
          onClick={() => navigate('/login')}
          style={{ width: '100%', padding: '18px', borderRadius: 9999, background: 'transparent', color: 'white', fontSize: 17, fontWeight: 600, border: '2px solid rgba(255,255,255,0.6)', cursor: 'pointer' }}>
          Log in to an account
        </button>
      </div>
    </div>
  );
};

export default WelcomePage;
